// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Rxoi","socialAnchor":"Footer_socialAnchor__1w9IS","termLink":"Footer_termLink__3PdkE"};